module.exports = __webpack_public_path__ + "img/transparent.b1d370b0.png";